<template>
<v-layout column>
    <h1>Users</h1>
    <v-data-table
        :headers="headers"
        :items="users"
        :loading="ui.loading"
        :hide-actions="users.length <= 5"
        class="elevation-4 mt-4"
    >
        <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
        <template slot="items" slot-scope="props">
            <tr>
            <td>{{ props.item.name }}</td>
            <td>{{ props.item.email }}</td>
            <td>
                <v-checkbox
                v-model="props.item.access.admin"
                @change="modifyAccess(props.item.id, props.item.access)"
                ></v-checkbox>
            </td>
            <td>
                <v-checkbox
                v-model="props.item.access.manager"
                @change="modifyAccess(props.item.id, props.item.access)"
                ></v-checkbox>
            </td>
            <td>
                <v-checkbox
                v-model="props.item.access.employee"
                @change="modifyAccess(props.item.id, props.item.access)"
                ></v-checkbox>
            </td>
            <td>
                <v-tooltip left>
                <v-icon slot="activator" @click="deleteUser(props.item.id)" class="pointer">delete</v-icon>
                <span>Delete</span>
                </v-tooltip>
            </td>
            </tr>
        </template>
    </v-data-table>  
</v-layout>
</template>

<script>
import { db, functions } from '@/services/firebase.js'

export default {
    data () {
        return {
            ui: {
                loading: true,
                snackbar: false,
                snackbar_text: '',
            },
            headers: [
                { text: 'Name', align: 'left', value: 'name' },
                { text: 'Email', value: 'email' },
                { text: 'Admin', value: 'access.admin' },
                { text: 'Manager', value: 'access.manager' },
                { text: 'Employee', value: 'access.employee' },
                { text: 'Actions', value: '' }
            ],
            users: []
        }
    },
    computed: {
        isAdmin () {
            return this.$store.getters.isAdmin !== null && this.$store.getters.isAdmin !== undefined
        },
        isManager () {
            return this.$store.getters.isManager !== null && this.$store.getters.isManager !== undefined
        },
        isDark: function () {
            return this.$vuetify.dark
        }
    },
    methods: {
        modifyAccess: function(uid, claim_update){
            var self = this
            self.ui.loading = true
            var user = self.users.find((user) => {
                return user.id === uid
            })
            var modifyAccess = functions.httpsCallable('modifyUserAccess')
            modifyAccess({uid: uid, rule: claim_update})
            .then(() => {
                self.$root.$emit('event', {type: 'info', event: 'Updated user access for: ' + user.email + ' ' + JSON.stringify(claim_update)})
                self.ui.loading = false
            })
            .catch((err) => {
                console.error(err)
                self.$root.$emit('event', {type: 'error', event: 'User access was not updated for: ' + user.email})
                self.ui.loading = false
            })
        },
        deleteUser: function(uid){
            var self = this
            if(!self.ui.loading){
                self.ui.loading = true
                var user = self.users.find((user) => {
                    return user.id === uid
                })
                var deleteUser = functions.httpsCallable('deleteUser')
                deleteUser({uid: uid})
                .then((response) => {
                    if(response.data.success){
                        self.$root.$emit('event', {type: 'info', event: 'Deleted user: ' + user.email})
                        self.ui.loading = false
                    } else {
                        self.$root.$emit('event', {type: 'error', event: 'User was not deleted: ' + user.email})
                        self.ui.loading = false
                    }
                })
                .catch((err) => {
                    console.error(err)
                    self.$root.$emit('event', {type: 'error', event: 'User was not deleted: ' + user.email})
                    self.ui.loading = false
                })
            }
        }
    },
    created () {
        var self = this
        db.collection('users').onSnapshot(userSnapshot => {
            var users = []
            userSnapshot.forEach(function(doc) {
                users.push(doc.data())
            })
            self.users = users
            self.ui.loading = false
        })
    },
    mounted () {

    }
}
</script>

<style lang="stylus" scoped>
.v-datatable .v-input--selection-controls
    margin-top 16px
</style>